import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { CluWCashDeskLoyaltLandingClientInscriptionResult } from '../m-loyalty-landing.model';

@Component({
    selector     : 'md-loyalty-inscription-res',
    templateUrl  : './md-loyalty-inscription-res.component.html',
    styleUrls: ['./md-loyalty-inscription-res.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, MaterialModule, TablerIconsModule],
    providers : []
})
export class MdLoyaltyInscriptionResComponent implements OnInit 
{
    inscriptionResult : CluWCashDeskLoyaltLandingClientInscriptionResult;
    constructor(@Inject(MAT_DIALOG_DATA) private dataE: any, public matDialogRef: MatDialogRef<MdLoyaltyInscriptionResComponent>){
        this.inscriptionResult = this.dataE.res;
    }

    ngOnInit() { }

}